import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import RegisterChoice from "@/pages/RegisterChoice";
import RegisterStaff from "@/pages/RegisterStaff";
import BookService from "@/pages/BookService";
import ServiceDetail from "@/pages/ServiceDetail";
import Payment from "@/pages/Payment";
import Jobs from "@/pages/Jobs";
import Dashboard from "@/pages/Dashboard";
import StaffDashboard from "@/pages/StaffDashboard";
import AdminLayout, { AdminOverview, AdminBookings, AdminJobs, AdminUsers, AdminNotify, AdminEvents } from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="light" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<RegisterChoice />} />
            <Route path="/register/customer" element={<Register />} />
            <Route path="/register/staff" element={<RegisterStaff />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/services/:serviceKey" element={<ServiceDetail />} />
            <Route path="/book/:serviceKey" element={<BookService />} />
            <Route path="/payment/:bookingId" element={<Payment />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/staff" element={<StaffDashboard />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="notify" element={<AdminNotify />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
